import { inboxItems } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const inboxStatusSchema = z.enum([
  'new',
  'ai_processing',
  'ready',
  'in_progress',
  'done',
])

export const selectInboxItemSchema = createSelectSchema(inboxItems)

export const insertInboxItemSchema = createInsertSchema(inboxItems).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export type InboxItem = z.infer<typeof selectInboxItemSchema>
export type CreateInboxItem = z.infer<typeof insertInboxItemSchema>
export type InboxStatus = z.infer<typeof inboxStatusSchema>

// Re-export AI classification types from schema
export type { AiClassification, OpportunityPrefillData } from '@markku/db'
